import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

export interface HqProfile {
  userId: string;
  orgId: string;
  orgName?: string | null;
  deptId: string;
  deptName?: string | null;
  userCode?: string | null;
  name: string;
  /** 账号等级，如 L3（DR-8.6）。 */
  level: string;
  /** 后端下发的权限码；undefined 表示旧会话/开发态发号，不做前端菜单裁剪。 */
  perms?: string[];
  /** 个人账户：头像（资源服务 fileUrl）、脱敏手机、邮箱。 */
  avatarUrl?: string | null;
  mobile?: string | null;
  email?: string | null;
}

interface AuthState {
  token: string | null;
  profile: HqProfile | null;
  setSession: (token: string, profile: HqProfile) => void;
  /** 会话局部更新（头像/科室等由 /auth/me 补全）。 */
  patchProfile: (patch: Partial<HqProfile>) => void;
  clear: () => void;
}

/** Web 端令牌存内存 + sessionStorage（docs/05 §6-1），关浏览器即失效。 */
export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      token: null,
      profile: null,
      setSession: (token, profile) => set({ token, profile }),
      patchProfile: (patch) =>
        set((state) => ({ profile: state.profile ? { ...state.profile, ...patch } : null })),
      clear: () => set({ token: null, profile: null })
    }),
    {
      name: 'hq-hospital-auth',
      storage: createJSONStorage(() => sessionStorage)
    }
  )
);

export const getToken = (): string | null => useAuthStore.getState().token;
